import React from "react";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import LanguageRoundedIcon from "@mui/icons-material/LanguageRounded";
import { Box, Grid, Skeleton, Typography } from "@mui/material";

const SaleHeaderSkeleton: React.FC = () => {
  return (
    <div>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: "100%",
          border: "1px solid #EDEFEF",
          borderRadius: "5px",
          backgroundColor: "#F6F8F9",
        }}
      >
        <Box sx={{ width: "100%", height: "80%", padding: "10px 20px" }}>
          <Box display="flex" flexDirection="column" p={2}>
            <Grid
              container
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              <Grid
                item
                sx={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                  gap: "10rem",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "1.1rem",
                    color: "#1D4A87",
                    fontWeight: "600",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <AccountCircleRoundedIcon
                    sx={{
                      fontSize: "45px",
                      color: "#9AAFC4",
                      marginLeft: "15px",
                    }}
                  />
                  <Skeleton
                    variant="rectangular"
                    width={150}
                    height={15}
                    sx={{ borderRadius: "10px" }}
                  />
                </Typography>
                <Typography
                  sx={{
                    fontSize: "1.1rem",
                    color: "#1D4A87",
                    fontWeight: "600",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  کد ملی:{" "}
                  <Skeleton
                    variant="rectangular"
                    width={150}
                    height={15}
                    sx={{ borderRadius: "10px", marginRight: "7px" }}
                  />
                </Typography>
                <Typography
                  sx={{
                    fontSize: "1.1rem",
                    color: "#1D4A87",
                    fontWeight: "600",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  فروشنده:{" "}
                  <Skeleton
                    variant="rectangular"
                    width={150}
                    height={15}
                    sx={{ borderRadius: "10px", marginRight: "7px" }}
                  />
                </Typography>
              </Grid>
              <Grid item>
                <Typography
                  sx={{
                    fontSize: "1rem",
                    color: "#1D4A87",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <LanguageRoundedIcon
                    sx={{
                      fontSize: "20px",
                      marginLeft: "5px",
                    }}
                  />
                  <Skeleton
                    variant="rectangular"
                    width={150}
                    height={15}
                    sx={{ borderRadius: "10px" }}
                  />
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default SaleHeaderSkeleton;
